import { QuestionOptions } from './api'

export const QuestionOptionsFactorySymbol = Symbol.for("QuestionOptionsFactory");
export type QuestionOptionsFactory<TContent> = (questionType: string) => QuestionOptions<TContent>
